import React from "react";
import { useLocation } from "react-router";
import ContinueSection from "../../components/molecules/ContinueSection/ContinueSection";
import PrepaidReceipt from "../../components/organisms/PrepaidReceipt/PrepaidReceipt";
import "./Receipt.less";

export default function Receipt() {
    const location = useLocation();
    return (
        <div className="prepaid-registration">
            <PrepaidReceipt />
            <ContinueSection path={location.pathname} />
        </div>
    );
}
